import { type Commodity, hazmatClassesMap, hazmatPackingGroupMap } from '../domain/Commodity'

export function getHazmatClass(commodity: Commodity): string {
  return commodity.hazmatClass ? hazmatClassesMap.get(commodity.hazmatClass) ?? '-' : '-'
}

export function getHazmatPackingGroup(commodity: Commodity): string {
  return commodity.hazmatPackingGroup
    ? hazmatPackingGroupMap.get(commodity.hazmatPackingGroup) ?? '-'
    : '-'
}
